import React, { useEffect, } from 'react';
import { Modal, } from 'react-bootstrap';

import {
    dataTableLanguaje, responseGet, globalSettings, separatorsNumbersSet, styles, languageObjGet, isUndNullEmp, sendMessageCloseCurrentWindowAsync,
    awaitDelay, buttonProcessGet,
} from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { conceptModelGet } from '../../models/expenses/concept';
import { expenseTemplateModelGet } from '../../models/expenses/template';

const currentMethod = 'ConceptFind';

export default function ConceptFind({
    $ = {},
    auth = {},
    concepts = [conceptModelGet({})],
    template = expenseTemplateModelGet({}),
    dtConceptsId = '',
    dtConcepts = () => { },
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region concepts
    let conceptsChecked = [{
        id: '',
        description: '',
        quantity: 0.00,
        price: 0.00,
        created: new Date(),
        userId: auth?.user?.uid,
    }];
    const dtConceptsFindId = 'dtConceptsFind';
    const controls = {
        buttons: {
            save: {
                id: 'btnModalConceptsSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnModalConceptsBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnModalConceptsClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            // description: {
            //     id: 'inputDescription',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        dataTables: {
            conceptsFind: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtConceptsFindId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConceptsFindId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            save: {
                id: 'icoModalConceptsSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoModalConceptsBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        spinners: {
            save: {
                id: 'spModalConceptsSave',
                className: '',
            },
            back: {
                id: 'spModalConceptsBack',
                className: '',
            },
        },
    };
    //#endregion concepts

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region initialize
            conceptsChecked = [];
            //#endregion initialize

            //#region methods
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            }

            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            }

            $(`#${dtConceptsFindId}`)?.DataTable()?.rows?.add(concepts)?.draw(true);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtConceptsFindId}`)?.DataTable({
                columns: [
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '95%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[1, 'asc'], [0, 'asc']],
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let isChecked = '';
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtConceptsFindId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                rowIndex = $(`#${dtConceptsFindId}`)?.DataTable()?.row(this)?.index();
                if (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    isChecked = e?.target?.checked || false;
                    if (!isUndNullEmp({ data: id, subMethod: currentMethod, })?.result) {
                        switch (isChecked) {
                            case true:
                                conceptsChecked?.push({
                                    id: id,
                                    description: description,
                                    quantity: 0.00,
                                    price: 0.00,
                                    created: new Date(),
                                    userId: auth?.user?.uid,
                                });
                                break;
                            default:
                                conceptsChecked = conceptsChecked?.filter(({ id: idLocal, }) => idLocal !== id) || [];
                                break;
                        }
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'conceptsAddPostAsync';
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region data check
            if (isUndNullEmp({ data: conceptsChecked, subMethod: currentMethod, })?.result || conceptsChecked?.length <= 0) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustSelectRecord?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data check

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            //#region methods
            template.details = template?.details?.filter((concept) => !isUndNullEmp({ data: concept?.id, subMethod: currentMethod, })?.result);
            if (isUndNullEmp({ data: template?.details, subMethod: currentMethod, })?.result) {
                template.details = [];
            }

            conceptsChecked?.forEach((conceptChecked) => {
                const conceptFound = template?.details?.find(({ id }) => id === conceptChecked?.id);
                if (isUndNullEmp({ data: conceptFound, subMethod: currentMethod, })?.result) {
                    //#region variables
                    conceptChecked.quantity = 1.00;
                    const quantity = separatorsNumbersSet({
                        number: conceptChecked?.quantity,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    const price = separatorsNumbersSet({
                        number: conceptChecked?.price,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    const subTotal = separatorsNumbersSet({
                        number: (conceptChecked?.quantity * conceptChecked?.price),
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    //#endregion variables

                    //#region dtConcepts add
                    dtConcepts = $(`#${dtConceptsId}`)?.DataTable();
                    dtConcepts?.row?.add([
                        conceptChecked?.description,
                        quantity,
                        price,
                        subTotal,
                        buttonProcessGet({
                            id: conceptChecked?.id,
                            description: conceptChecked?.description,
                            showDetails: false,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: true,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: true,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])?.draw(true);
                    //#endregion dtConcepts add

                    //#region expenseTemplateDetails add
                    template?.details?.push({
                        id: conceptChecked?.id,
                        description: conceptChecked?.description,
                        quantity: conceptChecked?.quantity,
                        price: conceptChecked?.price,
                    });
                    //#endregion expenseTemplateDetails add
                }
            });
            //#endregion methods

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            //$(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

             //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

           //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

             //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.conceptsFind?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.conceptsFind?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide' })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseConceptsLogo}></img> - {globalSettings?.labels?.concept?.[languageObj?.id]} ({globalSettings?.labels?.add?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose' })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => conceptsAddPostAsync({ e: e, subMethod: 'form - onSubmit', })}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => conceptsAddPostAsync(e)}> */}
                    {/* <div className='card card-outline card-primary shadow-lg'> */}
                    {/*header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={globalSettings?.labels?.concept?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseConceptsLogo}></img> - {globalSettings?.labels?.concept?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/*body*/}
                    {/* <div className='card-body'> */}
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtConceptsFindId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/*footer*/}
                    {/* <div className='card-footer'>
                        <div className='form-group text-right'>
                            <button className='btn btn-outline-warning'
                                tooltip='tooltip'
                                title={globalSettings?.labels?.add?.[languageObj?.id]}
                                type='submit'>
                                <i className={globalSettings?.icons?.save}></i>
                            </button>
                            <button className='btn btn-outline-success mx-1'
                                tooltip='tooltip'
                                title={globalSettings?.labels?.close?.[languageObj?.id]}
                                type='reset'
                                onClick={() => defaultValueSetAsync(true)}>
                                <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                            </button>
                        </div>
                    </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.add?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack' })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}